module.exports = __webpack_public_path__ + "static/media/prop-1.4e06024c.jpg";